import appGlobalReducer from "./app-global/app-global-reducer";
import appSettingsReducer from "./app-settings/app-settings-reducer";
import authenticationReducer from "./authentication/authentication-reducer";
import initializationReducer from "./common/initialization/initialization-reducer";
import modalWindowReducer from "./common/modal-window/modal-window-slices";
import pageRefreshReducer from "./common/page-refresh/page-refresh-reducer";
import unsavedDataReducer from "./common/unsaved-data/unsaved-data-reducer";
import contactsReducer from "./contacts/contacts-reducer";
import addNewCustomersReducer from "./customers/add-new-customer/add-new-customer-reducer";
import customerDetailsReducer from "./customers/customer-details/customer-details-reducer";
import customersReducer from "./customers/customers-reducer";
import emailTemplatesReducer from "./deliverables/email-templates/email-templates-reducer";
import packagesReducer from "./deliverables/erp-packages/erp-packages-reducer";
import environmentHistoryReducer from "./environments/environment-history/environment-history-reducer";
import environmentsReducer from "./environments/environment-reducer";
import enrollTenantReducer from "./environments/tenants/enroll-tenant/enroll-tenant-reducer";
import mailboxesReducer from "./environments/tenants/mailboxes/mailboxes-slices";
import tenantDeleteReducer from "./environments/tenants/tenant-delete/tenant-delete-reducer";
import guestTenantsReducer from "./environments/tenants/tenant-guest-tenants/tenant-guest-tenants-reducer";
import pingReducer from "./environments/tenants/tenant-ping/tenant-ping-reducer";
import tenantStatusReducer from "./environments/tenants/tenant-status/tenant-status-reducer";
import tenantsReducer from "./environments/tenants/tenants-reducer";
import filtersReducer from "./filters/filters-reducer";
import informationLinksReducer from "./information-links/information-links-reducer";
import partnersReducer from "./partners/partners-reducer";

import {
    Action,
    combineReducers,
    configureStore,
    ThunkAction,
} from "@reduxjs/toolkit";

const rootReducer = combineReducers({
    addNewCustomersReducer,
    appGlobalReducer,
    appSettingsReducer,
    authenticationReducer,
    contactsReducer,
    customerDetailsReducer,
    customersReducer,
    emailTemplatesReducer,
    enrollTenantReducer,
    environmentHistoryReducer,
    environmentsReducer,
    filtersReducer,
    guestTenantsReducer,
    informationLinksReducer,
    initializationReducer,
    mailboxesReducer,
    modalWindowReducer,
    packagesReducer,
    pageRefreshReducer,
    partnersReducer,
    pingReducer,
    tenantDeleteReducer,
    tenantStatusReducer,
    tenantsReducer,
    unsavedDataReducer,
});

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
            immutableCheck: false,
        }),
});

export type RootState = ReturnType<typeof rootReducer>;

export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;

export type AppDispatch = typeof store.dispatch;

export default store;
